import dayjs from 'dayjs';
import localisedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localisedFormat);
const FLOATING_POINT_PRECISION = 2;
const CENTS_PER_RAND = 100;

export const displayCurrency = (amount?: number) => {
  if (amount == null || amount === undefined) {
    return '';
  }

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(amount / 100);
};

/** @deprecated Use displayCurrency instead. If you are converting from string you need to convert to number before calling currency */
export const currency = (amount: any, modifier = 100) => {
  if (amount == null || amount === undefined) {
    return '';
  }

  // This extracts the first number from the input string, it also returns an absolute value.
  const amountReg = amount.toString().match(/[\d.]+/);
  if (amountReg) {
    amount = amountReg[0];
  } else {
    return '';
  }

  const formatted = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(amount / modifier);

  return formatted;
};

export const displayDate = (date: string | Date | undefined | number): string => dayjs(date).format('L');

export const displayDateTime = (date: string | Date | undefined | number): string => {
  const d = dayjs(date);
  if (!d.isValid()) {
    return date ? String(date) : '';
  }
  return d.format('L LT');
};

export const toCents = (amount: number): number => {
  return Math.round(Number((amount * CENTS_PER_RAND).toFixed(FLOATING_POINT_PRECISION)));
};

export const toRand = (amount: number): number => {
  if (!amount) {
    return 0;
  }
  return amount / CENTS_PER_RAND;
};
